import React from 'react';

export default ({
    images,
    imagesPerRow,
}) => (
        <div className="row align--center">
            <div className="col c8--md">
                <div className={'mb4 mt4 mb6--md mt6--md gallery gallery--' + imagesPerRow}>
                    {createImages(images, imagesPerRow)}
                </div>
            </div>
        </div>
    );

/**
 * Creates the image tags to go in the gallery.
 *
 * @param {Array<Object>} images The info on the images.
 * @param {number} imagesPerRow The number of images per row.
 */
function createImages(images, imagesPerRow) {
	let gallery = [];

	images.map(image => {
		let aspectRatio;
		switch (imagesPerRow) {
			case 1:
				aspectRatio = 'size--16x9';
				break;
			case 2:
				aspectRatio = 'size--1x1';
				break;
		}
		gallery.push(
			<div className={'image ' + aspectRatio}>
				<picture key={image._key}>
					<source
						srcSet={`${image.url}?w=2000&auto=format&q=75`}
						media='(min-width: 1000px)'
					/>
					<source
						srcSet={`${image.url}?w=1600&auto=format&q=75`}
						media='(min-width: 800px)'
					/>
					<img alt={image.alt} src={`${image.url}?w=800&auto=format&q=75`} />
				</picture>
			</div>,
		);
	});

	return gallery;
}